import { Button, ButtonProps } from '../../Button';

interface TableBulkActionButtonProps extends Partial<ButtonProps> {
    bulkActionBarEnabled?: boolean;
}

const TableBulkActionButton = ({
    children,
    disabled,
    icon,
    bulkActionBarEnabled = false,
    ...rest
}: TableBulkActionButtonProps) => {
    const variant = bulkActionBarEnabled && disabled ? 'ghost' : 'primary';
    return (
        <Button
            disabled={disabled}
            icon={icon}
            variant={variant}
            iconPosition="left"
            size="small"
            {...rest}
            type="submit"
        >
            {children}
        </Button>
    );
};

export default TableBulkActionButton;
